import React from 'react';
import { Box } from '@mui/material';
import { neutral } from '_lex/_foundations/phxColors';

import type { ConnectorProps } from './types';

const Connector: React.FC<ConnectorProps> = ({ solid, dimmed = false }) => (
  <Box
    sx={{
      flex: 1,
      borderTop: `1px ${solid ? 'solid' : 'dashed'} ${neutral[400]}`,
      minWidth: 20,
      transition: 'border-color 200ms ease-in-out, opacity 200ms ease-in-out',
      ...(dimmed && { opacity: 0.5 }),
    }}
  />
);

export default Connector;
